import * as React from 'react';
import * as s from 'styled-components';
import NavDropdown from '../NavDropdown/NavDropdown';
import { Link } from 'react-router';
import { FlexRow, FlexRowCenter } from '../../Flexbox/Flexbox';
import { withTheme } from 'styled-components';

const styled = s.default;

interface Props {
  // TODO : any -> typ
  name: string;
  url?: string;
  fontSize?: string;
  padding?: string;
  children?: any;
  onMouseLeave?: any;
  absolute?: boolean;
  isHoveringNav?: boolean;
  customStyle?: any;
  toggleDim?: (data: boolean) => void;
  handleNavHoverStatus?: (data: boolean) => void;
  handleNavSearchInput?: (data: string) => void;
  setActiveChild?: (i: number) => void;

  highlightColor?: string;

  amount?: number;
  isEmpty?: boolean;
  type?: string;

  confirmAttribsFilter?: any;
  cancelAgeChanges?: any;
  confirmAgeAttribFilter?: any;
  resetAllAttribsByName?: any;
  resetNavMenu?: any;
  theme: any;
  className?: string;
  withoutHoverEffect?: boolean;
}

interface State {
  active: boolean;
  isHovering: boolean;
}

class NavItem extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      isHovering: false,
    };
  }

  public handleMouseEnter = () => {
    this.setState({ isHovering: true });

    if (!this.props.withoutHoverEffect) {
      setTimeout(() => {
        if (this.state.isHovering) {
          this.setState({ active: true });
          if (this.props.toggleDim && this.props.children) {
            this.props.toggleDim(true);
          }
          if (this.props.handleNavHoverStatus && this.props.children) {
            this.props.handleNavHoverStatus(true);
          }
        }
      }, 300);
    } else {
      if (this.state.isHovering) {
        this.setState({ active: true });
        if (this.props.toggleDim && this.props.children) {
          this.props.toggleDim(true);
        }
        if (this.props.handleNavHoverStatus && this.props.children) {
          this.props.handleNavHoverStatus(true);
        }
      }
    }
  };

  public handleMouseLeave = () => {
    this.setState({ ...this.state, isHovering: false });
    if (this.props.handleNavHoverStatus) {
      this.props.handleNavHoverStatus(false);
    }

    setTimeout(() => {
      if (this.state.isHovering === false) {
        if (this.props.onMouseLeave) {
          this.props.onMouseLeave();
        }
        this.setState({ ...this.state, active: false });
        if (this.props.toggleDim) {
          if (this.props.isHoveringNav) {
            return;
          }
          this.props.toggleDim(false);
        }
        if (this.props.handleNavSearchInput) {
          this.props.handleNavSearchInput('');
        }
        if (this.props.setActiveChild) {
          this.props.setActiveChild(0);
        }
      }
    }, 100);
  };

  public handleRedirect = () => {
    this.resetNavMenu();
  };

  public render() {
    const { children, name, url, theme } = this.props;

    const highlightColor =
      this.props.highlightColor || theme.fontHighlightColor;

    const arrowIcon =
      this.props.highlightColor === theme.colors.secondaryFontColor ||
      theme.secondaryFontColor
        ? `${process.env.REACT_APP_URL}/images/dropdown-arrow-green.svg`
        : `${process.env.REACT_APP_URL}/images/dropdown-arrow-active.svg`;

    const childrenHandler = () => {
      switch (this.props.type) {
        case 'age':
          return (
            <React.Fragment>
              {children &&
                React.cloneElement(children, {
                  cancelAgeChanges: this.cancelAgeChanges,
                  confirmAgeAttribFilter: this.confirmAgeAttribFilter,
                  confirmAttribsFilter: this.confirmAttribsFilter,
                })}
            </React.Fragment>
          );

        case 'filter':
          return (
            <React.Fragment>
              {children &&
                React.cloneElement(children, {
                  confirmAttribsFilter: this.confirmAttribsFilter,
                  resetAllAttribsByName: this.resetAllAttribsByName,
                })}
            </React.Fragment>
          );

        case 'theme':
          return (
            <React.Fragment>
              {children &&
                React.cloneElement(children, {
                  confirmAttribsFilter: this.confirmAttribsFilter,
                  resetAllAttribsByName: this.resetAllAttribsByName,
                })}
            </React.Fragment>
          );

        case 'top':
          return (
            <React.Fragment>
              {children &&
                React.cloneElement(children, {
                  resetNavMenu: this.resetNavMenu,
                })}
            </React.Fragment>
          );

        default:
          return <React.Fragment>{children && children}</React.Fragment>;
      }
    };

    return (
      <NavItemComponent
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        highlightColor={this.props.highlightColor}
        className={this.props.className}
      >
        {this.props.url && this.props.url.length > 0 ? (
          <StyledLink to={`/${url}`} onClick={this.handleRedirect}>
            <Text
              fontSize={this.props.fontSize}
              padding={this.props.padding}
              style={{ color: this.state.active ? highlightColor : undefined }}
            >
              {name}
            </Text>
            {this.props.isEmpty !== true && (
              <Arrow
                style={{
                  transform: this.state.active
                    ? 'rotate(-180deg)'
                    : 'rotate(0deg)',
                }}
                src={
                  this.state.active ? arrowIcon : '/images/dropdown-arrow.svg'
                }
              />
            )}
          </StyledLink>
        ) : (
          <AttribWrapper>
            <TextWithNumber
              style={{ color: this.state.active ? highlightColor : undefined }}
            >
              {name}
            </TextWithNumber>

            {this.props.amount && this.props.amount > 0 ? (
              <AmountNumber>{this.props.amount}</AmountNumber>
            ) : null}

            {this.props.isEmpty !== true && (
              <Arrow
                style={{
                  transform: this.state.active
                    ? 'rotate(-180deg)'
                    : 'rotate(0deg)',
                }}
                src={
                  this.state.active ? arrowIcon : '/images/dropdown-arrow.svg'
                }
              />
            )}
          </AttribWrapper>
        )}

        <NavDropdown
          style={{
            opacity: this.state.active === true ? 1 : 0,
            pointerEvents: this.state.active ? 'all' : 'none',
            position: this.props.absolute ? 'absolute' : 'static',
          }}
          disablePadding={true}
        >
          {childrenHandler()}
        </NavDropdown>
      </NavItemComponent>
    );
  }

  public closeDropdown = () => {
    if (this.props.toggleDim) {
      this.props.toggleDim(false);
    }
    if (this.props.handleNavHoverStatus) {
      this.props.handleNavHoverStatus(false);
    }
    if (this.props.onMouseLeave) {
      this.props.onMouseLeave();
    }
    this.setState({ isHovering: false, active: false });
  };

  public cancelAgeChanges = (...params) => {
    this.closeDropdown();
    this.props.cancelAgeChanges(...params);
  };

  public confirmAgeAttribFilter = (...params) => {
    this.closeDropdown();
    this.props.confirmAgeAttribFilter(...params);
  };

  public confirmAttribsFilter = (...params) => {
    this.closeDropdown();
    this.props.confirmAttribsFilter(...params);
  };

  public resetAllAttribsByName = (...params) => {
    this.closeDropdown();
    this.props.resetAllAttribsByName(...params);
  };

  public resetNavMenu = (...params) => {
    this.closeDropdown();
    this.props.resetNavMenu(...params);
  };
}

export default withTheme(NavItem);

const AttribWrapper = styled(FlexRow)`
  align-items: center;
`;

export const AmountNumber: any = styled(FlexRowCenter)`
  margin-left: 5px;
  margin-right: 3px;
  background-color: ${({ theme }) => theme.secondaryFontColor};
  color: #ffffff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
`;

const TextWithNumber = styled.span`
  cursor: pointer;
`;

const Text: any = styled.span`
  cursor: pointer;
  font-size: ${(props: any) => props.fontSize || '16px'};
  padding: ${(props: any) => props.padding || 0};
`;

const NavItemComponent: any = styled.div`
  font-family: ${({ theme }) => theme.secondaryFont};
  list-style-type: none;
  padding: 0;
  margin-right: 30px;
  transition: color 0.2s;
  color: ${({ theme }) =>
    theme.colors.primaryFontColor || theme.primaryFontColor};

  &:hover > span {
    ${(props: any) => {
      return `
        color: ${props.highlightColor || props.theme.fontHighlightColor}
      `;
    }};
  }
`;

const StyledLink: any = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) =>
    theme.colors.primaryFontColor || theme.primaryFontColor};

  &:hover > span {
    ${(props: any) => {
      return `
        color: ${props.highlightColor || props.theme.fontHighlightColor}
      `;
    }};
  }
`;

const Arrow = styled.img`
  width: 10px;
  height: 10px;
  vertical-align: middle;
  transition: all 0.2s;
  position: relative;
  cursor: pointer;
  margin-left: 10px;
`;
